import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'completion-indicator',
    templateUrl: './completion-indicator.component.html',
    standalone: false
})
export class CompletionIndicatorComponent {
  points = input.required<number>();
  pointsMax = input.required<number>();
  notStarted = computed(() => (this.points() === 0));
  complete = computed(() => (this.points() >= this.pointsMax()));
  incomplete = computed(() => (this.points() > 0 && this.points() < this.pointsMax()));
}
